export const ORG_COOKIE = "elkcargo_default_selected_org";
const LONG_TERM_COOKIE_MAX_AGE = 60 * 60 * 24 * 30;

export function setOrgCookieClient(orgSlug: string) {
  const maxAge = LONG_TERM_COOKIE_MAX_AGE;
  document.cookie = `${ORG_COOKIE}=${orgSlug}; path=/; max-age=${maxAge}; secure; samesite=strict`;
}
